(function () {
  'use strict';

  var PRICE_LIST_SELECTOR = 'price-list';
  var SOURCE_SELECTOR = '.amend-price-source, .ymq-b2b-price-span, [ymq-b2b-variant-price]';
  var scheduled = false;

  function getHeader() {
    return document.querySelector('store-header.header');
  }

  function getConfig(priceList) {
    var header = getHeader();
    var isProduct = !!(priceList && priceList.classList.contains('amend-main-product-price'));

    if (!header) {
      return {
        isProduct: isProduct,
        decimal: 'dot',
        currencyPosition: 'after'
      };
    }

    return isProduct
      ? {
          isProduct: true,
          decimal: header.dataset.amendProductDecimal || 'dot',
          currencyPosition: header.dataset.amendProductCurrencyPosition || 'after'
        }
      : {
          isProduct: false,
          decimal: header.dataset.amendOtherDecimal || 'dot',
          currencyPosition: header.dataset.amendOtherCurrencyPosition || 'after'
        };
  }

  function parsePrice(raw) {
    raw = (raw || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    if (!raw) return null;

    if (/kostenlos|free/i.test(raw)) {
      return { free: true, raw: raw };
    }

    var match = raw.match(/-?\d[\d\s.,']*/);
    if (!match) return null;

    var token = match[0].replace(/[\s']/g, '');
    var negative = token.charAt(0) === '-';
    token = token.replace(/^-/, '');

    var lastComma = token.lastIndexOf(',');
    var lastDot = token.lastIndexOf('.');
    var decimalPos = Math.max(lastComma, lastDot);
    var majorDigits;
    var cents = '00';

    if (decimalPos >= 0) {
      var tail = token.slice(decimalPos + 1).replace(/\D/g, '');
      if (tail.length > 0 && tail.length <= 2) {
        majorDigits = token.slice(0, decimalPos).replace(/\D/g, '');
        cents = tail.padEnd(2, '0').slice(0, 2);
      } else {
        majorDigits = token.replace(/\D/g, '');
      }
    } else {
      majorDigits = token.replace(/\D/g, '');
    }

    if (!majorDigits) majorDigits = '0';

    var prefix = raw.slice(0, match.index).trim();
    var suffix = raw.slice(match.index + match[0].length).trim();
    var currencyCodeMatch = suffix.match(/\b[A-Z]{3}\b/);
    var currencyCode = currencyCodeMatch ? currencyCodeMatch[0] : '';

    prefix = prefix.replace(/[€$£¥]/g, '').trim();
    suffix = suffix
      .replace(/[€$£¥]/g, '')
      .replace(/\b[A-Z]{3}\b/g, '')
      .replace(/^[\s,;:\-]+|[\s,;:\-]+$/g, '')
      .trim();

    return {
      free: false,
      majorDigits: (negative ? '-' : '') + String(parseInt(majorDigits, 10) || 0),
      cents: cents,
      prefix: prefix,
      suffix: suffix,
      currencyCode: currencyCode
    };
  }

  function formatMajor(digits, decimalStyle) {
    var negative = String(digits).charAt(0) === '-';
    var clean = String(digits).replace(/^-/, '');
    var thousands = decimalStyle === 'dot' ? ',' : '.';
    var formatted = clean.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return negative ? '-' + formatted : formatted;
  }

  function captureOriginalTypography(source) {
    if (!source || !window.getComputedStyle) return;
    if (source.dataset.amendOriginalTypography === '1') return;

    var style = window.getComputedStyle(source);
    if (style.fontSize) source.style.setProperty('--amend-original-price-size', style.fontSize);
    if (style.lineHeight && style.lineHeight !== 'normal') {
      source.style.setProperty('--amend-original-price-line-height', style.lineHeight);
    }
    source.dataset.amendOriginalTypography = '1';
  }

  function renderSource(source, priceList) {
    if (!source || source.closest('[data-amend-product-price]')) return;

    // B2C prices are already structured by Liquid in the first HTML response.
    // Do not touch them again: this avoids any visual/value delay and keeps YMQ out of B2C.
    if (source.matches && source.matches('[data-amend-b2c-instant-price]')) return;

    var raw = (source.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    var parsed = parsePrice(raw);
    if (!parsed) return; // z.B. "Bitte anmelden" von YMQ unverändert lassen

    var config = getConfig(priceList);
    var signature = parsed.free
      ? ['free', config.isProduct ? 'product' : 'other'].join('|')
      : [
          parsed.majorDigits,
          parsed.cents,
          parsed.prefix,
          parsed.suffix,
          parsed.currencyCode,
          config.decimal,
          config.currencyPosition,
          config.isProduct ? 'product' : 'other'
        ].join('|');

    // Wenn YMQ denselben Preis erneut als Klartext einsetzt, muss trotzdem wieder formatiert werden.
    var alreadyStructured = !!source.querySelector('.amend-price-major, .amend-price-free');
    if (alreadyStructured && source.dataset.amendPriceSignature === signature) return;

    captureOriginalTypography(source);

    var currency = '€';
    var separator = config.decimal === 'dot' ? '.' : ',';
    var fragment = document.createDocumentFragment();

    function addSpan(className, value) {
      if (value === null || value === undefined || value === '') return;
      var span = document.createElement('span');
      span.className = className;
      span.textContent = value;
      fragment.appendChild(span);
    }

    if (parsed.free) {
      addSpan('amend-price-free', /free/i.test(parsed.raw) ? 'Free' : 'Kostenlos');
    } else {
      if (parsed.prefix) addSpan('amend-price-prefix', parsed.prefix + ' ');

      if (config.currencyPosition === 'before') {
        addSpan('amend-price-currency', currency);
      }

      addSpan('amend-price-major', formatMajor(parsed.majorDigits, config.decimal));
      addSpan('amend-price-separator', separator);
      addSpan('amend-price-cents', parsed.cents);

      if (config.currencyPosition !== 'before') {
        addSpan('amend-price-currency', currency);
      }

      if (parsed.currencyCode) addSpan('amend-price-code', ' ' + parsed.currencyCode);
      if (parsed.suffix) addSpan('amend-price-suffix', ' ' + parsed.suffix);
    }

    source.__amendFormatting = true;
    source.replaceChildren(fragment);
    source.classList.add('amend-price-source--formatted');
    source.dataset.amendPriceScope = config.isProduct ? 'product' : 'other';
    source.dataset.amendCurrencyPosition = config.currencyPosition;
    source.dataset.amendPriceSignature = signature;
    source.__amendFormatting = false;
  }

  function processPriceList(priceList) {
    if (!priceList || !priceList.querySelectorAll) return;

    var candidates = Array.prototype.slice.call(priceList.querySelectorAll(SOURCE_SELECTOR));
    var leaves = candidates.filter(function (node) {
      return !node.querySelector(SOURCE_SELECTOR);
    });

    leaves.forEach(function (source) {
      renderSource(source, priceList);
    });
  }

  function processStandaloneCartTotals(root) {
    if (!root || !root.querySelectorAll) return;

    var totals = Array.prototype.slice.call(root.querySelectorAll('[ymq-b2b-cart-total-price]'));
    totals.filter(function (node) {
      return !node.querySelector('[ymq-b2b-cart-total-price]') && !node.closest('price-list');
    }).forEach(function (source) {
      renderSource(source, null);
    });
  }

  function scan(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.matches && root.matches(PRICE_LIST_SELECTOR)) {
      processPriceList(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(PRICE_LIST_SELECTOR).forEach(processPriceList);
      processStandaloneCartTotals(root);
    }
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scan(document);
    });
  }

  function start() {
    scheduleScan();

    var observer = new MutationObserver(function (mutations) {
      var fallbackFullScan = false;

      mutations.forEach(function (mutation) {
        var target = mutation.target && mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target && mutation.target.parentElement;

        if (!target || !target.closest) {
          fallbackFullScan = true;
          return;
        }

        if (target.closest('.amend-price-source--formatted') && target.__amendFormatting) return;

        // YMQ schreibt B2B-Preise asynchron in bestehende Preis-Knoten.
        // Den betroffenen Preis sofort neu formatieren statt jedes Mal das ganze Dokument zu scannen.
        var list = target.closest(PRICE_LIST_SELECTOR);
        if (list) {
          processPriceList(list);
        } else if (target.matches('[ymq-b2b-cart-total-price], .ymq-b2b-price-span, [ymq-b2b-variant-price], .amend-price-source')) {
          renderSource(target, null);
        }

        mutation.addedNodes && mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(PRICE_LIST_SELECTOR)) processPriceList(node);
          if (node.querySelectorAll) node.querySelectorAll(PRICE_LIST_SELECTOR).forEach(processPriceList);
          processStandaloneCartTotals(node);
        });
      });

      if (fallbackFullScan) scheduleScan();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    [150, 500, 1200, 2500].forEach(function (delay) {
      window.setTimeout(scheduleScan, delay);
    });

    document.addEventListener('shopify:section:load', scheduleScan);
    document.addEventListener('shopify:section:select', scheduleScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
